import { Typography } from "@mui/material";
import { OrgScopedBaseUser } from "src/stores/models/user";
import {
  QualityEventAnswers,
  QualityEventField,
  qualityEventRows,
} from "src/types/quality-events";
import { QualityEventFieldValue } from "./QualityEventFieldValue";

type RepeatableField = Extract<QualityEventField, { type: "repeatable" }>;

export const QualityEventRepeatableHeading = ({
  qualityEventKey,
  stepKey,
  field,
  rowId,
  sourceAnswers,
  files,
  orgId,
  users,
}: {
  qualityEventKey?: string;
  stepKey: string;
  field: RepeatableField;
  rowId: string;
  sourceAnswers: QualityEventAnswers;
  files: { id: string; filename: string }[];
  orgId: string;
  users: OrgScopedBaseUser[];
}) => {
  if (qualityEventKey !== "capa") return null;
  const fromPlan = field.sourceRows?.stepKey === "action-plan";
  const sourceRows = (field.sourceRows?.fieldKeys ?? [field.key]).flatMap(
    (key) => qualityEventRows(sourceAnswers[key])
  );
  const matchingRows = sourceRows.filter((row) => row.id === rowId);
  const name =
    matchingRows.length === 1 ? matchingRows[0].answers.name : undefined;
  const heading =
    typeof name === "string" && name.trim()
      ? `Action Plan ${name}`
      : "Action Plan";
  const criteria =
    matchingRows.length === 1
      ? matchingRows[0].answers.effectivenessCriteria
      : undefined;
  return (
    <>
      {(field.isActionPlan || fromPlan) && (
        <Typography
          component="h3"
          variant="subtitle1"
          color="text.secondary"
          className="m-0"
        >
          {heading}
        </Typography>
      )}
      {stepKey === "effectiveness" && fromPlan && (
        <div>
          <Typography variant="body2" color="text.disabled">
            Predefined effectiveness criteria
          </Typography>
          <QualityEventFieldValue
            field={{
              key: "effectivenessCriteria",
              label: "Predefined effectiveness criteria",
              type: "rich_text",
            }}
            value={typeof criteria === "string" ? criteria : undefined}
            files={files}
            orgId={orgId}
            users={users}
          />
        </div>
      )}
    </>
  );
};
